import { Result, Button, Typography } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useAuth } from '@/contexts/AuthContext'

const { Text } = Typography

const NoPermissionsPage = () => {
  const { user, logout } = useAuth()

  return (
    <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Result
        icon={<LockOutlined style={{ fontSize: 64, color: '#faad14' }} />}
        title="Account non configurato"
        subTitle={
          <div style={{ marginTop: 8 }}>
            <p>
              L'utente <strong>{user?.username}</strong> non ha ancora nessun permesso assegnato.
            </p>
            <Text type="secondary">
              Contatta l'amministratore di sistema per ricevere i permessi necessari all'accesso.
            </Text>
          </div>
        }
        extra={
          <Button type="primary" danger onClick={logout}>
            Esci
          </Button>
        }
      />
    </div>
  )
}

export default NoPermissionsPage
